<template>
  <el-dialog
    title="正在识别中"
    :visible.sync="innerVisible"
    width="420px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
    append-to-body
    @closed="handleClosed"
  >
    <div class="content">
      <div class="text">正在识别中，请稍候…</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button :disabled="closeDisabled" @click="handleCloseClick">
        {{ closeButtonText }}
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'RecognizingDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    minWaitSeconds: {
      type: Number,
      default: 60
    }
  },
  data () {
    return {
      innerVisible: false,
      remainingSeconds: 0,
      timer: null
    };
  },
  computed: {
    closeDisabled () {
      return this.remainingSeconds > 0;
    },
    closeButtonText () {
      return this.remainingSeconds > 0 ? `关闭（${this.remainingSeconds}s）` : '关闭';
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler (val) {
        this.innerVisible = val;
        if (val) {
          this.startCountdown();
        } else {
          this.resetCountdown();
        }
      }
    },
    innerVisible (val) {
      if (val !== this.visible) {
        this.$emit('update:visible', val);
      }
    }
  },
  beforeDestroy () {
    this.clearTimer();
  },
  methods: {
    startCountdown () {
      this.clearTimer();
      const seconds = Number(this.minWaitSeconds) || 0;
      this.remainingSeconds = seconds;
      if (this.remainingSeconds <= 0) return;

      this.timer = setInterval(() => {
        if (this.remainingSeconds <= 1) {
          this.remainingSeconds = 0;
          this.clearTimer();
          return;
        }
        this.remainingSeconds -= 1;
      }, 1000);
    },
    resetCountdown () {
      this.clearTimer();
      this.remainingSeconds = 0;
    },
    clearTimer () {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    handleCloseClick () {
      if (this.closeDisabled) return;
      this.innerVisible = false;
      this.$emit('close');
    },
    handleClosed () {
      this.resetCountdown();
    }
  }
};
</script>

<style scoped>
.content {
  min-height: 48px;
  display: flex;
  align-items: center;
}
.text {
  font-size: 14px;
  line-height: 22px;
}
</style>
